import type { TemplateConfigInput } from '@server/trading-templates/schemas/input.schema';
import type { TradingIndicatorConfig } from '@client/widgets/trading-form/trading-form.types';

type IndicatorsTemplateConfig = Extract<TemplateConfigInput, { type: 'indicators' }>;
type IndicatorsTemplateValue = IndicatorsTemplateConfig['value'];

// Indicators templates are now pure snapshots of the indicators section, so converting
// between form state and persisted template value is just a defensive deep copy.
export const formIndicatorsToTemplateValue = (
  indicators: TradingIndicatorConfig[]
): IndicatorsTemplateValue => structuredClone(indicators);

// Applying/restoring an indicators template should not keep any linkage to the source template,
// so we return a detached copy of the stored indicator snapshot.
export const templateValueToFormIndicators = (
  value: IndicatorsTemplateValue
): TradingIndicatorConfig[] => structuredClone(value);
